module.exports = __webpack_public_path__ + "img/bg_share.e86ec030.png";